import { Link } from "react-router-dom";
import { Routes } from "./routes";
import type { AnalyticsPopupConfig } from "./analyticsPopupConfig";

export interface TeamPolicySource {
  cookiePolicyText?: string;
  termsOfUseText?: string;
  privacyPolicyText?: string;
  analyticsTrackingEnabled?: boolean | string;
  analyticsPopupConfig?: Pick<AnalyticsPopupConfig, "cookieSettingsLabel"> | null;
}

export interface TeamPolicyLink {
  to: string;
  label: string;
}

export function teamPolicyLinks(team?: TeamPolicySource | null): TeamPolicyLink[] {
  if (!team) return [];
  const links: TeamPolicyLink[] = [];
  if (team.cookiePolicyText?.trim()) {
    links.push({ to: Routes.COOKIE_POLICY, label: "Cookie Policy" });
  }
  if (team.termsOfUseText?.trim()) {
    links.push({ to: Routes.TERMS_OF_USE, label: "Terms of Use" });
  }
  if (team.privacyPolicyText?.trim()) {
    links.push({ to: Routes.PRIVACY_POLICY, label: "Privacy Policy" });
  }
  if (team.analyticsTrackingEnabled === true) {
    links.push({
      to: Routes.COOKIE_SETTINGS,
      label: team.analyticsPopupConfig?.cookieSettingsLabel?.trim() || "Cookie Settings",
    });
  }
  return links;
}
